import { observable, action, computed, flow, toJS, runInAction } from 'mobx';
import { Toast, Modal } from 'antd-mobile';
import axios from 'axios';
import Util from 'utils';
import Config from 'config/Config';
import { rstr2b64, hex_md5, Encrypts } from 'utils/md5';
import Stores from 'config/Stores';
import {
  openCardTextLess,
  oldOpenCardText,
  popupPositionMap
} from 'utils/constants';
import { fetchData } from 'pubBiz/ActiveAdPopup/fetchData';
import Serv from './RegisterServ';

const Alert = Modal.alert;

class RegisterMod {
  @observable cardCode = '';
  // 是否邀请注册
  @observable isInvite = false;
  // 正反面证件
  @observable imgList = [];
  // // 邀请人卡号
  // @observable inviteCode = '';

  // uniqueId, 获取验证码时，后台返回的，用于后台校验
  @observable uniqueId = '';

  @observable phone = '';

  @observable userName = '';

  @observable code = '';

  @observable codeLoading = false;

  // 健康顾问
  @observable consultant = '';

  // 销售顾问 LSH站点显示销售顾问，需要用户手填
  @observable sale = '';

  //
  @observable preConsultant = '';

  // 邀请人的会员卡号
  @observable InviteConsultant = '';

  // 健康顾问是否可编辑
  @observable consultantEditable = true;

  // 是否立即开卡
  @observable isApply = false;

  // 是否同意协议
  @observable isAgree = false;

  // 用户unionId
  @observable unionId = '';

  @observable ticket = '';

  @observable cardInfo = {};

  @observable isLyCode = '';

  @observable cardInfoName = '';

  // 销售顾问会员姓名
  @observable saleCardInfoName = '';

  // 是否需要注册订单
  @observable needRegisterOrder = 0;

  // 无需注册时的开卡订单id
  @observable registerCardTypeId = '';

  // 分享卡类型ID
  @observable cardTypeId = null;

  // 显示卡号密码弹框
  @observable showCardTip = false;

  // 卡号密码信息
  @observable infoData = {};

  // 是否提示卡类型
  @observable showTipToast = false;

  // 是否允许请求
  @observable allowRquest = true;

  // 姓名
  @observable realName = '';

  // 证件类型
  @observable identityType = 1;

  // 身份证正反面图片
  @observable imgList = [];

  // 证件号码
  @observable identityCard = null;

  // 生日
  @observable birthday = null;

  // 性别
  @observable sex = null;

  // 民族列表
  @observable nationList = [];

  // 民族
  @observable nation = null;

  @observable cardInfoState = {};

  // 其它证件类型禁用的站点编号列表
  @observable disableSystemCodeList = [];

  // 所属地区
  @observable belongArea = '';

  /**
   * 修改参数逻辑
   */
  @action
  changeState(key, value) {
    if (key == 'consultant' && value == 'undefined') {
      value = '';
    }
    this[key] = value;
  }

  /**
   * 重置数据
   */
  @action
  clearData() {
    this.noticeContent = '';
    this.agencyContent = '';
    this.uniqueId = '';
    this.phone = '';
    this.belongArea = '';
    this.userName = '';
    this.code = '';
    this.codeLoading = false;
    this.consultant = '';
    this.isApply = false;
    this.isAgree = false;
    this.unionId = '';
    this.ticket = '';
  }

  /**
   * 获取图形二维码
   */
  getCaptcha = flow(function* (phone) {
    try {
      const data = yield Serv.getCaptcha(phone);
      return null;
    } catch (error) {}
  });

  /**
   * 校验图形二维码
   */
  getImageCode = flow(function* (code) {
    try {
      const result = yield Serv.getImageCode({
        imgCode: code,
        phone: this.phone
      });
      const { data } = result || {};
      return data;
    } catch (error) {}
  });

  /**
   * 获取验证码
   * @param {Number} descriptionType - 注册场景
   * @param {String} [inviteMember] - 当为邀请注册时，邀请人的卡号
   */
  getVerifyCode = flow(function* (descriptionType, inviteMember, extObj, verifyCodeData) {
    const { imageCode } = extObj || {};
    const timestamp = new Date().getTime();
    try {
      if (this.codeLoading) return;
      this.codeLoading = true;
      let params = {
        healthConsultantNum: this.consultant,
        phone: this.phone,
        descriptionType: Util.getLocalCache('isVirtualPoint') ? 10 : descriptionType, // 0 - 邀请注册 1 - 注册，2 - 登录，3 - 找回密码，4 - 通过卡密绑定手机号，5 - 更换手机号，7 - 通过个人中心绑定手机号，8 - 通过个人中心更换手机号，10 - 代客注册，11 - 开店
        codeType: 2, // 1 - 图像验证码，2 - 手机验证码，3 - 邮箱验证码,
        md5Sign: encodeURIComponent(
          Encrypts(
            `${timestamp}#${hex_md5(this.phone.replace(/\s*/g, '') + Util.getSendMsgParamsUat()).toUpperCase()}`
          )
        ),
        areaCode: Stores.AppMod.areaCode
      };
      imageCode && (params.imageCode = imageCode);
      let data = {};
      let resultMsg = '';
      let resultCode = '';
      if (verifyCodeData) {
        data = verifyCodeData.data;
        resultMsg = verifyCodeData.resultMsg;
        resultCode = verifyCodeData.resultCode;
      } else {
        if (Util.getLocalCache('onlineAddress') === '1' && !!Util.getLocalCache('onlineUserId')) {
          params.userId = Util.getLocalCache('onlineUserId');
        }
        const res = yield Serv.getVerifyCode(params);
        data = res.data;
        resultMsg = res.resultMsg;
        resultCode = res.resultCode;
      }
      this.codeLoading = false;
      // if (+resultCode === 3333 && params.phone) {
      //   this.getCaptcha(params.phone);
      //   return resultCode;
      // }
      // 9999 代表该手机号已经被注册普客，弹出框让用户选择去登录并开卡
      if (resultCode == '9999') {
        Alert('', resultMsg, [
          { text: '取消' },
          { text: '确定', onPress: () => window.app.routerRedirect('/login') }
        ]);
        return;
      }
      if (resultCode != '0') {
        Toast.fail(resultMsg, 1);
        return;
      }
      if (data.healthConsultantNum && data.healthConsultantNum != '8888888888') {
        this.consultant = data.healthConsultantNum;
        this.consultantEditable = false;
      } else {
        if (sessionStorage.getItem('systemCode') == 'LY' || this.isLyCode == 'LY') {
          // this.consultantEditable = true;
        } else {
          if (this.consultant && this.consultant != '8888888888') {
            this.consultant =
              this.consultant || data.healthConsultantNum || inviteMember || '8888888888'; // 健康顾问填充为邀请者的cardCode 可修改
          } else {
            this.consultant = data.healthConsultantNum || inviteMember || '8888888888'; // 健康顾问填充为邀请者的cardCode 可修改
          }
          this.consultantEditable = true;
        }
      }
      if (data && data.uniqueId) {
        !verifyCodeData && Toast.info(resultMsg, 2);
        this.uniqueId = data.uniqueId;
        return data;
      }
      return null;
    } catch (error) {
      this.codeLoading = false;
      return null;
    }
  });

  /**
   * 获取用户微信unionId
   * @param {String} [openId] - 微信openId
   * @param {String} [thirdToken] - 微信token
   */
  getUnionId = flow(function* ({ openId, thirdToken }) {
    const { data } = yield Serv.getWxMsgByToken({
      openId,
      accessToken: thirdToken
    });
    this.unionId = data.unionid;
    return data;
  });

  getMemberInfoByPhone = flow(function* (phone) {
    const { data } = yield Serv.getMemberInfoByPhone({ phone });
    return data;
  });

  getCardCodeInfo = flow(function* (cardCode, resetFlag = false) {
    if (this.preConsultant == cardCode.cardCode) return false;
    Toast.loading();
    // const { data } = yield Serv.getCardCodeInfo(cardCode);
    const { data } = yield Serv.getCardCodeInfoNew(cardCode);
    const { code = '', needRegisterOrder, registerCardTypeId } = data || {};
    this.isLyCode = code || '';
    this.needRegisterOrder = needRegisterOrder;
    this.registerCardTypeId = registerCardTypeId;
    !resetFlag && (this.identityType = 1);
    // 注册时开卡重置
    if (needRegisterOrder === 0) {
      this.isApply = false;
    }
    // console.log(data);
    // mobx失效了，不知道咋回事， 用promise吧
    // this.cardInfo = data;
    Toast.hide();
    this.preConsultant = cardCode.cardCode;
    return data;
  });

  getCardCodeName = flow(function* (cardCode) {
    const { data } = yield Serv.getCardCodeName(cardCode);
    this.cardInfoName = data || '';
  });

  /**
   * 获取销售顾问姓名
   *
   * @memberof RegisterMod
   */
  getSaleCardCodeName = flow(function* (cardCode) {
    const { data } = yield Serv.getCardCodeName(cardCode);
    this.saleCardInfoName = data || '不存在';
  });

  /**
   * 注册
   * quetion: 怎么有那么多微信信息？
   * answer: ① 微信登录时没有账号而前来注册的，会存在openId和thirdToken，一注册就帮用户绑定微信和三生账号
   * ② 非微信登录时前来注册，拉起授权框，再处理出unionId，这时只传unionId给后台，忽略openId和thirdToken，做到又能得到unionId，又不帮用户绑定微信
   * @param {String} [openId] - 微信openId
   * @param {String} [thirdToken] - 微信token
   * @param {String} [unionId] - 微信unionId
   * @param {String} [wxChatId] - 企微id
   */
  register = flow(
    async function* (
      openId,
      thirdToken,
      ticket,
      unionId,
      isSmartCard,
      codeForLY,
      extObj,
      registerAndLogin,
      registerAndLoginKey,

      wxChatId
    ) {
      const { userInfo } = Stores.AppMod;
      const { belongSystem } = userInfo || {};
      const smartcardId = Util.getLocalCache(Config.localStorageKeys.share_id);
      const { nickname, headimgurl, inletTitle, shareUserId, shareType } = extObj || {};
      try {
        const { consultant } = this;
        if (!consultant) {
          Toast.info('请输入健康顾问', 2);
          return;
        }
        if ((this.disable || !this.allowRquest) && !registerAndLoginKey) return;
        this.allowRquest = false;
        let shareId = Util.getLocalCache(Config.localStorageKeys.share_link_Id) || '';
        let params = {
          fromCardFlag: isSmartCard.id || smartcardId ? 1 : 0,
          shareInviterId: isSmartCard.id || smartcardId || '',
          uniqueId: this.uniqueId,
          phone: this.phone,
          belongArea: this.belongArea,
          // ...(codeForLY=='LY'?{
          userName: this.userName || this.phone,

          // }:{}),
          verifyCode: this.code,
          openCardFlag: this.isApply ? 0 : 1,
          applicationType: 1,
          codeType: 2,
          channel: 3, // 注册渠道, 应东哥要求，说是H5传4是错误的，应该是3，但这个4是交付代码
          customerSource: Util.isWeiXin() ? 1 : ticket ? 34 : 5, // 34的值来源于潘斌剑
          saleConsultantNum: Util.getLocalCache('shareSaleCardCode') || '',
          shareId: (shareId && shareId.toString()) || ''
        };
        if (registerAndLogin) {
          params.registerAndLogin = registerAndLogin;
          params.registerAndLoginKey = registerAndLoginKey;
        }
        if (wxChatId) {
          params.wxChatId = wxChatId;
        }
        if (!!sessionStorage.getItem('xm_openId') && !!sessionStorage.getItem('xm_accessToken')) {
          // 享脉参数
          params.openId = sessionStorage.getItem('xm_openId');
          params.accessToken = sessionStorage.getItem('xm_accessToken');
        }
        // !!Util.getLocalCache('shareSaleCardCode') && (params.fromXYTeamShareFlag = 1);
        params.fromXYTeamShareFlag = Util.getLocalCache('fromTeamShareFlag') || 0;
        nickname && (params.nickname = nickname);
        headimgurl && (params.headimgurl = headimgurl);
        // if (Util.getLocalCache('isVirtualPoint')) {
        //   let shareId = Util.getLocalCache(Config.localStorageKeys.share_link_Id) || ''
        //   let params = {
        //     phone: this.phone,
        //     uniqueId: this.uniqueId,
        //     verifyCode: this.code,
        //     healthConsultantNum: Stores.AppMod.userInfo.cardCode,//Util.getLocalCache('member_userInfo').healthConsultantNum,
        //     applicationType: 1,
        //     codeType: 2,
        //     channel: 3, // H5渠道
        //     customerSource: Util.isWeiXin() ? 1 : 5, // 微信 - 0，非微信打开 - 4
        //     saleConsultantNum: Util.getLocalCache('shareSaleCardCode') || '',
        //     shareId: shareId && shareId.toString() || '',
        //   };
        //   // !!Util.getLocalCache('shareSaleCardCode')
        //   // && (params.fromXYTeamShareFlag = (Util.getLocalCache('fromTeamShareFlag') || ''));
        //   params.fromXYTeamShareFlag = (Util.getLocalCache('fromTeamShareFlag') || 0)
        //   params.areaCode = Stores.AppMod.areaCode;
        //   const {data} = yield Serv.registerVirtual(params);
        //   if (data) {
        //     // IM注册
        //     // Stores.AppMod.setImLogin({
        //     //   userId: data.id || data.userId
        //     // })
        //     Util.setLocalCache('virtualUserId', data.id);
        //     Util.setLocalCache('shareSaleCardCode','')  // 清空分享销售顾问
        //     Util.setLocalCache(Config.localStorageKeys.share_link_Id,'')  // 清空分局分享shareId
        //     let callback = null;

        //     console.log('注册获取', Util.getLocalCache('virtualNeedOrder'), Util.getLocalCache('virtualFreeFreight'), Util.getLocalCache('virtualUserId'));
        //     if(Util.getLocalCache('virtualNeedOrder') == 1){
        //       // 使用虚拟资格 注册开卡 需要订单 跳转产品选购页
        //       callback = () =>{
        //         window.app.routerGoTo({
        //           pathname: '/register/memGiftbag',
        //           clear: true,
        //           state: {
        //             applyType: '3',
        //           },
        //         });
        //       };
        //     }else{
        //       // 不需要订单
        //       callback = () =>{
        //         window.app.routerGoTo({
        //           pathname: '/register/memCardMsg',
        //           state: {
        //             id: data.id,
        //             applyType: '',
        //           },
        //         });
        //       };
        //     }

        //     fetchData({popupPosition: popupPositionMap.REGISTRATION_COMPLETED},()=>{callback()},()=>{callback()})

        //   }
        //   return;
        // }
        if (openId && thirdToken) {
          params.openId = openId;
          params.accessToken = thirdToken;
        }
        if (unionId) params.unionId = unionId;
        if (this.consultant) {
          params.healthConsultantNum = this.consultant;
          params.saleConsultantNum = this.consultant;
        }
        if (this.sale) {
          params.saleConsultantNum = this.sale;
        }
        if (this.isInvite) {
          params.descriptionType = 0;
        }
        console.log('params', params);
        // 增加loading
        Toast.loading();
        if (this.needRegisterOrder == 0) {
          params.cardTypeId = this.registerCardTypeId;
        }
        if (this.needRegisterOrder !== 0 && this.isApply) {
          params.registerCardReqDto = {
            realName: this.realName,
            identityType: this.identityType,
            identityCard: this.identityCard,
            birthday: this.birthday,
            sex: this.sex,
            nation: this.nation
          };
        }
        params.areaCode = Stores.AppMod.areaCode;
        if (Util.getLocalCache('onlineAddress') === '1' && !!Util.getLocalCache('onlineUserId')) {
          params.userId = Util.getLocalCache('onlineUserId');
        }
        params.ticket = ticket;
        console.log('RegisterMod params', params);
        let data = null;
        if (ticket) {
          const result = yield Serv.registerGoogle(params);
          data = result && result.data;
        } else {
          const result = yield Serv.register(params);
          data = result && result.data;
        }
        console.log('data12', data);
        let LYName = this.userName;
        // 用户可能在登录状态下，重新注册，所以及时清除掉以前的用户本地数据 及 应用LoginMod数据也要清除
        // LY登录
        const lyCode = sessionStorage.getItem('systemCode');
        const shareInletTitle = sessionStorage.getItem('shareInletTitle');
        Stores.AppMod.clearData();
        Stores.LoginMod.clear();
        lyCode && sessionStorage.setItem('systemCode', lyCode);
        lyCode && sessionStorage.setItem('LYFlag', 'true');
        shareInletTitle && sessionStorage.setItem('shareInletTitle', shareInletTitle);

        this.allowRquest = true;
        if (data && codeForLY == 'LY') {
          Util.setLocalCache('LYuserName', LYName);
        }

        if (data && inletTitle) {
          window.sensors.track('userlifeCycle', {
            information_title: inletTitle,
            type: 3, // type 1,2,3,4 区分点击、登录、注册、下单
            channel: 'H5',
            userId: data.userId || '',
            cardCode: data.cardCode || ''
          });
        }

        if (data && shareUserId) {
          window.sensors.track('birthdayShareStatistics', {
            source_channal: shareType,
            share_user_id: shareUserId,
            user_id: data.userId || '',
            userId: data.userId || ''
          });
        }

        if (data && shareInletTitle) {
          window.sensors.track('userlifeCycle', {
            information_title: `${shareInletTitle}-分享链接`,
            type: 3, // type 1,2,3,4 区分点击、登录、注册、下单
            channel: 'H5',
            userId: data.userId || '',
            cardCode: data.cardCode || ''
          });
        }

        const sessionInletTitle = sessionStorage.getItem('inletTitle');
        if (sessionInletTitle) {
          // 微信绑定页注册登录
          sessionStorage.setItem('inletTitleType', 3);
        }

        // 保存登录信息
        Stores.AppMod.saveLoginInfo(data).then((res) => {
          Util.setLocalCache(Config.localStorageKeys.share_link_Id, ''); // 清空分局分享shareId
          Util.setLocalCache('shareSaleCardCode', ''); // 清空分享销售顾问
          if (belongSystem == 'KER' || this.isLyCode == 'KER') {
            Stores.AppMod.setKerUpdateHealth(); // 可儿玫瑰更新健康顾问
          }
          // 神策数据发送
          window.sensors.track('register', { phone: params.phone });

          Stores.AppMod.jumpVerse(true);
        });
        // IM注册
        // Stores.AppMod.setImLogin({
        //   userId: data.id || data.userId
        // })
        this.consultantEditable = true;

        if (belongSystem == 'KER' || this.isLyCode == 'KER') {
          Stores.AppMod.setKerUpdateHealth(); // 可儿玫瑰更新健康顾问
        }
        console.log('isApply>>>>>', this.isApply);
        Toast.hide();
        if (!this.isApply) {
          Toast.success('恭喜注册成功', 1, () => {
            // 存储信息
            const { cardCode, userPassValue, realName, registerTime } = data || {};
            !!cardCode &&
              this.changeState('infoData', {
                cardCode,
                password: userPassValue,
                realName: this.userName,
                createTime: registerTime
              });
            if (
              this.isInvite &&
              this.cardTypeId &&
              (belongSystem == 'KER' || this.isLyCode == 'KER')
            ) {
              // 可儿玫瑰跳转升级
              this.changeState('showTipToast', true);
              if (Object.keys(this.infoData).length > 0) {
                this.changeState('showCardTip', true);
                return;
              }
              // this.applyNextUpgrade()
            }

            // 可儿玫瑰、极萃 如果有卡号直接弹框
            if (belongSystem == 'KER' || this.isLyCode == 'KER' || this.isLyCode == 'JCH') {
              if (Object.keys(this.infoData).length > 0) {
                this.changeState('showCardTip', true);
                return;
              }
            }
            // 弹框逻辑
            if (this.needRegisterOrder == 0) {
              // 登录时的注册
              if (registerAndLoginKey) {
                Stores.ShopHomeMod.changeState({
                  showModal: true,
                  upgrate: false,
                  member_userInfo: data
                });
                Util.setLocalCache('registerMember_Info', data || '');
                window.app.routerGoTo('/shop/home');
              } else if (Object.keys(this.infoData).length > 0) {
                this.changeState('showCardTip', true);
              }
              return;
            }
            if (openId && thirdToken && unionId) {
              // this.linkflowIdentifiers({
              //   externalId: Stores.AppMod.userInfo.id,
              //   mobilePhone: Stores.AppMod.userInfo.phone,
              //   weChatInfo: {
              //     appId: Config.wxAppId,
              //     openId: openId,
              //     unionId: unionId,
              //   },
              // });
            }
            const callback = this.registerAfter;
            fetchData(
              { popupPosition: popupPositionMap.REGISTRATION_COMPLETED },
              () => {
                callback();
              },
              () => {
                callback();
              }
            );
          });
          return true;
        }
        Toast.success('恭喜注册成功', 1);

        const { phone } = this;
        // 注册成功，清除表单数据
        // this.queryCanApplyType(phone);

        const callback = () => {
          this.applyNext({ inletTitle }); // 跳转预览礼包
          this.clearData();
        };
        fetchData(
          { popupPosition: popupPositionMap.REGISTRATION_COMPLETED },
          () => {
            callback();
          },
          () => {
            callback();
          }
        );
        return true;
      } catch (error) {
        console.log('error', error);
        this.allowRquest = true;
      }
    }
  );

  @action
  registerAfter = () => {
    const registerRoute = Util.getLocalCache(Config.localStorageKeys.registerRoute) || ''; // 登录后是否返回原来页面的标识

    // 清除缓存
    this.clearData();

    // 跳转回分享过来的链接
    if (registerRoute) {
      const isSXY = registerRoute.indexOf('learn/finding') > -1;
      if (isSXY && !!Stores.AppMod.workWechatAgentId) {
        Util.handleSXYLearning();
        return;
      }
      sessionStorage.removeItem('routerCount');
      window.location.replace(`/#${registerRoute}`);
      Util.setLocalCache(Config.localStorageKeys.registerRoute, ''); // 登录后是否返回原来页面的标识
      Util.setLocalCache(Config.localStorageKeys.loginGoback, ''); // 登录后是否返回原来页面的标识
      Util.setLocalCache(Config.localStorageKeys.share_card_code, '');
      return;
    }

    // 是否返回上一个页面的标识
    let loginGoback = Util.getLocalCache(Config.localStorageKeys.loginGoback);
    // 返回上一页的地址
    if (loginGoback) {
      Util.setLocalCache(Config.localStorageKeys.registerRoute, '');
      Util.setLocalCache(Config.localStorageKeys.loginGoback, '');
      if (registerRoute) {
        const isSXY = registerRoute.indexOf('learn/finding') > -1;
        if (isSXY && !!Stores.AppMod.workWechatAgentId) {
          Util.handleSXYLearning();
        } else {
          window.app.routerGoTo(registerRoute);
        }
      } else {
        window.app.routerGoTo('/shop/home');
      }
    } else {
      window.app.routerGoTo('/shop/home');
    }
  };

  /**
   * 如果是注册即开卡 则弹出卡号密码弹框
   *
   * @memberof RegisterMod
   */
  @action
  madolOpen = () => {
    this.showOpenMadol = true;
  };

  // 注册成功之后的逻辑
  goRegisterNext = () => {
    if (!this.isApply) {
      Toast.success('恭喜注册成功', 1, () => {
        const registerRoute = Util.getLocalCache(Config.localStorageKeys.registerRoute) || ''; // 登录后是否返回原来页面的标识

        // 清除缓存
        this.clearData();
        // 跳转回分享过来的链接
        if (registerRoute) {
          window.app.routerRedirect(registerRoute);
          Util.setLocalCache(Config.localStorageKeys.registerRoute, ''); // 登录后是否返回原来页面的标识
          Util.setLocalCache(Config.localStorageKeys.loginGoback, ''); // 登录后是否返回原来页面的标识
          Util.setLocalCache(Config.localStorageKeys.share_card_code, '');
          return;
        }

        window.app.routerGoTo({ pathname: '/shop/home' });
      });
      return true;
    }
    Toast.success('恭喜注册成功', 1);

    const { phone } = this;
    // 注册成功，清除表单数据
    // this.queryCanApplyType(phone);
    this.applyNext(); // 跳转预览礼包
    this.clearData();
  };

  /**
   * 查询是否可开实体卡或虚拟卡
   */
  queryCanApplyType = flow(function* (phone) {
    try {
      const params = {
        channel: 0,
        healthConsultantCardCode: this.consultant || '8888888888'
      };
      const { data } = yield Serv.queryCanApplyType(params);
      // 0 - 只能开虚拟卡，1 - 只能开实体卡，2 - 可开虚拟卡或实体卡
      if (data != 0) {
        // ignoreFictitious: 是否不可开虚拟卡
        window.app.routerGoTo({
          pathname: '/register/physicalCard',
          state: {
            ignoreFictitious: data == 1,
            applyType: '3',
            phone,
            isInvite: this.isInvite
            // inviteCode: this.inviteCode == params.healthConsultantCardCode ? this.inviteCode : '',
          }
        });
      } else {
        window.app.routerGoTo({
          pathname: '/register/memCardMsg',
          clear: true,
          state: {
            applyType: '3',
            phone,
            isInvite: this.isInvite
            // inviteCode: this.inviteCode == params.healthConsultantCardCode ? this.inviteCode : '',
          }
        });
      }
    } catch (error) {}
  });

  // 邀请注册自主升级
  applyNextUpgrade = flow(function* () {
    try {
      Toast.loading();
      const { certType, consultant, isAgree: agree, cardTypeId } = this;
      const { cardCode = '' } = Stores.AppMod.userInfo || consultant;

      const params = {
        bizUpgradeCardReqDto: {
          cardCode,
          channel: 1
        }
      };
      const { data } = yield Serv.queryCardType(params);
      Util.setLocalCache(Config.localStorageKeys.member_cardTypeData, data);
      Toast.hide();
      const { cardCode: cardCodeValue } = this.infoData;
      if (cardTypeId == -1 || !cardTypeId) {
        const { cardCode: cardCodes } = this.infoData;
        // 不限制
        window.app.routerRedirect({
          pathname: '/register/memGiftbag',
          clear: false,
          defaultCheck: true,
          state: {
            applyType: '4', // '4'会员升级
            HealthyCardCode: cardCodeValue,
            backToPersonal: true
          }
        });
        window.location.reload();
      } else {
        let item = data.find((item) => item.id == cardTypeId);
        if (!item || !item.id) {
          Toast.fail('无购买权限，请联系健康顾问', 2, () => {
            window.app.routerRedirect({ pathname: '/shop/home' });
            window.location.reload();
          });
          return;
        }
        window.app.routerRedirect({
          pathname: '/register/memGiftbag',
          clear: false,
          defaultCheck: true,
          state: {
            applyType: '4', // '4'会员升级
            card: {
              orderCondition: item.orderCondition,
              bv: item.bv,
              bvMode: item.bvMode,
              id: item.id,
              maxItemNum: item.maxItemNum,
              minItemNum: item.minItemNum,
              itemPriceType: item.itemPriceType,
              maxAmount: item.maxAmount,
              minAmount: item.minAmount,
              type: item.type,
              supplementInfo: item.supplementInfo
            },
            HealthyCardCode: cardCodeValue,
            cardTypeId
          }
        });
        window.location.reload();
      }
    } catch (err) {}
  });

  /**
   * 自主开卡新逻辑
   */
  applyNext = flow(function* (exParams) {
    const { inletTitle = '' } = exParams || {};
    try {
      const { certType, consultant: healthConsultantNum, isAgree: agree } = this;
      const params = {
        registerCardReqDto: {
          healthConsultantNum,
          isEntityCard: 0, // 虚拟卡
          channel: 0,
          agree
        }
      };
      // 被邀请开卡的，传多一个参数
      if (this.isInvite) {
        params.registerCardReqDto.inviteCode = params.registerCardReqDto.healthConsultantNum;
      }

      const { resultCode, resultMsg, data } = yield Serv.apply(params);
      if (resultCode == 9998) {
        this.initHealthy = '';
        this.healthy = '';
        this.getHealthyUser();
        Toast.fail('健康顾问已更新，请重新填写销售顾问~', 2);
        return;
      }
      if (resultCode != 0) {
        Toast.fail(resultMsg, 3);
        return;
      }

      // 神策数据发送
      window.sensors.track('registerMember', {});

      Toast.success(
        `提交成功，选购产品即可完成${
          Stores.AppMod.userInfo.memberRetail ? openCardTextLess : oldOpenCardText
        }`,
        1,
        () => {
          Util.setLocalCache(
            Config.localStorageKeys.member_applyCardMsg,
            params.registerCardReqDto
          );

          Util.setLocalCache(Config.localStorageKeys.member_cardTypeData, data);

          window.app.routerGoTo({
            pathname: '/register/memGiftbag',
            clear: true,
            state: {
              applyType: '3', // '3'代表自主开卡类型的礼包选购
              HealthyCardCode: healthConsultantNum,
              backToPersonal: true,
              inletTitle
            }
          });
        }
      );
    } catch (error) {}
  });

  /**
   * 校验实体卡密是否正确
   * @param {String} cardNum - 会员卡号
   * @param {String} password - 会员密码
   * @param {String} applyType - 开卡类型 '3' - 自主开卡，'4' - 会员升级，'5' - 新客注册
   * @param {String} agentId - A代B开卡，B的userId
   * @param {String} healthy - A代B开卡，B的健康顾问
   */
  applyPhysicalCard = flow(
    function* (cardNum, password, applyType, agentId, healthy, phone, isInvite) {
      try {
        const params = {
          cardCode: cardNum,
          password: rstr2b64(password)
        };
        yield Serv.applyPhysicalCard(params);
        // 验证成功，跳转开卡
        window.app.routerGoTo({
          pathname: '/register/memCardMsg',
          clear: true,
          state: {
            physicalCardNum: cardNum,
            physicalCardPwd: rstr2b64(password),
            applyType,
            agentId,
            healthy,
            phone,
            isInvite
          }
        });
      } catch (error) {}
    }
  );

  /**
   * 按钮是否不可点
   */
  @computed get disable() {
    if (this.ticket) {
      return !(
        this.phone &&
        (Util.getLocalCache('isVirtualPoint')
          ? this.isAgree
          : (this.isApply && this.isAgree) || !this.isApply) &&
        Util.checkInput(this.consultant, 'account') &&
        this.saleInCorrect
      );
    }
    return !(
      this.uniqueId &&
      this.code.length > 3 &&
      (Util.getLocalCache('isVirtualPoint')
        ? this.isAgree
        : (this.isApply && this.isAgree) || !this.isApply) &&
      (Stores.AppMod.areaCode != 86 ? true : Util.checkInput(this.phone, 'mobile')) &&
      Util.checkInput(this.consultant, 'account') &&
      this.saleInCorrect
    );
  }

  // 麟莎站点，注册需要填写正确销售顾问
  @computed get saleInCorrect() {
    const bindCardCode = Util.getLocalCache('bindCardCode') || '';
    if (!bindCardCode) return true;
    return (
      bindCardCode &&
      (!bindCardCode.includes('LSH') ||
        (bindCardCode.includes('LSH') &&
          this.sale &&
          this.saleCardInfoName &&
          this.saleCardInfoName !== '不存在'))
    );
  }

  // linkflow识别联系人
  linkflowIdentifiers = flow(function* (params) {
    yield Serv.linkflowIdentifiers(params);
  });

  /**
   * 获取民族列表
   */
  getNationList = flow(function* (memberNum) {
    try {
      const { data } = yield Serv.getNationList({ cardCode: memberNum });
      if (Array.isArray(data)) {
        this.nationList = data.map((_val) => ({ label: _val.name, value: _val.id }));
      }
    } catch (error) {}
  });

  /**
   * 手机号获取健康顾问卡号
   */
  queryHealthCardCodeByPhone = flow(function* () {
    try {
      const { data } = yield Serv.queryHealthCardCodeByPhone({ phone: this.phone });
      const bindCardCode =
        Util.getQueryString('shareCardCode') ||
        Util.getQueryString('bindCardCode') ||
        Stores.AppMod.bindCardCode.cardCode ||
        Stores.AppMod.isCardCode.cardCode ||
        Util.getLocalCache('bindCardCode') ||
        '';
      this.consultant = data || bindCardCode || '8888888888';
      const cardInfoState = yield this.getCardCodeInfo({
        cardCode: data || bindCardCode || '8888888888',
        register: true
      });
      this.cardInfoState = cardInfoState;
      this.getCardCodeName((data || bindCardCode) != '8888888888' ? data || bindCardCode : '');
    } catch (error) {}
  });
}
const registerMod = new RegisterMod();
export default registerMod;



// WEBPACK FOOTER //
// ./src/pages/Register/RegisterMod.js